import React from "react";
import Services from "../../services/Services";
import snackbarService from "../../services/ui-messaging/SnackbarService";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import uuid from "uuid/v4";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import IAdminPanelServiceCall from "../../models/IAdminPanelServiceCall";
import { selectStatusDispatch } from "../../store/status/selectors";

export interface ICompleteSignupButtonProps {
  token: string;
  call: IAdminPanelServiceCall;
  addPending: Function;
  completePending: Function;
}

const CompleteSignUpButton = (props: ICompleteSignupButtonProps) => {
  const svcs: Services = new Services();

  const handleCompleteSignUp = async () => {
    const signupRepo = await svcs.SignUpRepository();
    const item = {
      id: uuid(),
      description: "Completing signup...",
    };
    props.addPending(item);

    try {
      await signupRepo.CompleteUserSignUp(props.token, props.call);
      window.location.reload();
    } catch (error) {
      snackbarService.error(error);
    }
    props.completePending(item);
  };

  const handleResendEmail = async () => {
    const signupRepo = await svcs.SignUpRepository();
    const item = {
      id: uuid(),
      description: "Resending email...",
    };

    const {
      addPending,
      token,
      call: { companyID, uniqueDistrictEmail, contactID },
    } = props;

    addPending(item);
    try {
      await signupRepo.SendEmail(token, companyID, uniqueDistrictEmail, contactID);
      snackbarService.success("Email sent.");
    } catch (error) {
      snackbarService.error(error);
    }
    props.completePending(item);
  };

  if (props.call.internalStatus.toLowerCase() === "hold") {
    return (
      <Button key={props.call.uniqueDistrictEmail} variant="outlined" onClick={() => handleCompleteSignUp()}>
        Complete Signup
      </Button>
    );
  } else if (props.call.internalStatus.toLowerCase() === "closed") {
    return (
      <Button key={props.call.uniqueDistrictEmail} variant="outlined" onClick={() => handleResendEmail()}>
        Resend Signup Email
      </Button>
    );
  }
  // show nothing
  return <span>&nbsp;</span>;
};

export default connect(
  (state: IApplicationState) => ({
    ...selectAuth(state),
  }),
  dispatch => ({
    ...selectStatusDispatch(dispatch),
  }),
)(CompleteSignUpButton);
